<template>
	<div class="mute-btn">
		<a href="#" :class="['speaker-icon', position, { muted: muted }]" @click.prevent="toggleMute">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.9 25.69" v-bind:class="'speaker-svg'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M19.48.16L9.33 6.39v-.1H3a3 3 0 00-3 3v6.81a3.28 3.28 0 003.28 3.28H9l10.5 6.16a1.1 1.1 0 001.5-.39 1.19 1.19 0 00.15-.55V1.09A1.09 1.09 0 0020.05 0a1.14 1.14 0 00-.57.16z" fill="#2a201b"/><g class="waves" fill="#2a201b"><path d="M30.86 5.37a1.32 1.32 0 00-1.8-.46L29 5a1.32 1.32 0 00-.4 1.78 12.39 12.39 0 010 12.37 1.34 1.34 0 00.4 1.68 1.32 1.32 0 001.84-.23l.09-.14a15.16 15.16 0 00-.05-15.1zM24.37 7.43l-.19.16a1.2 1.2 0 00-.31 1.57A7.42 7.42 0 0125 13a7.85 7.85 0 01-1 3.77 1.26 1.26 0 00.2 1.53l.12.11a1.23 1.23 0 001.68-.05 1.33 1.33 0 00.14-.19 9.88 9.88 0 000-10.42 1.22 1.22 0 00-1.68-.39z"/></g></svg>
		</a>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { isOneOf } from "@/lib/validators";

export default {
	name: 'MuteToggle',
	props: {
		position: {
			type: String,
			required: false,
			default: "bottom-right",
			validator: isOneOf(["top-right", "top-left", "bottom-right", "bottom-left"]),
		},
	},
	computed: {
		...mapState({
			muted: (state) => state.sound.muted,
		}),
	},
	methods: {
		toggleMute() {
			this.$store.dispatch("sound/toggle");
		},
	},
};
</script>

<style lang="scss" scoped>
	$icon-spacing: 1vmin;

	.speaker-icon {
		display: inline-block;
		height: 25px;
		width: 25px;
		position: fixed;
		overflow: hidden;
		z-index: $z-top + $z-top;

		@include desktop {
			height: 30px;
			width: 30px;
		}

		&.top-left { top: $icon-spacing; left: $icon-spacing; }
		&.top-right { top: $icon-spacing; right: $icon-spacing; }
		&.bottom-left { bottom: $icon-spacing; left: $icon-spacing; }
		&.bottom-right {
			bottom: 2vmin;
			right: 5vmin;

			@include desktop {
				bottom: 2vmin;
				right: 2vmin;
			}
		}


		& /deep/ .waves { transition: all $ui-transition-duration; }

		&:hover {
			& /deep/ .waves { transform: translate(-10%, 0); }
		}
		&.muted {
			& /deep/ .waves {
				transform: translate(-50%, 0);
				opacity: 0;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/base/MuteToggle.vue